import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import { formatDate } from "../../../../constants/helper";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Container, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const LaporanPenjualanPerNota = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();

  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal),
  );
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal),
  );

  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");
  const [cabangs, setCabangs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapPenjualanPerNotas, setLapPenjualanPerNotas] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanPenjualanPerNota",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, 1000);

      const laporanPenjualanPerNota = await axios.post(
        `${tempUrl}/laporanPenjualanPerNotaVer2`,
        {
          dariTanggal,
          sampaiTanggal,
          kodeCabang,
          _id: user.id,
          token: user.token,
        },
      );

      setLapPenjualanPerNotas(laporanPenjualanPerNota.data);
      setPreviewPdf(true);
      setLoading(false);

      setTimeout(() => {
        tempPersenLoading = 0;
        setPersenLoading(tempPersenLoading.toString());
      }, 2000);
    }
  };

  useEffect(() => {
    getCabangsData();

    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const textBold = {
    fontWeight: 700,
    border: "1px solid black",
  };

  const textRight = {
    textAlign: screenSize >= 650 ? "right" : "left",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const textNumberRightBold = {
    textAlign: "right",
    fontWeight: 700,
    border: "1px solid black",
  };

  const textCenter = {
    textAlign: "center",
    border: "1px solid black",
  };

  const textCenterBold = {
    textAlign: "center",
    fontWeight: 700,
    border: "1px solid black",
  };

  const textGroupHeader = {
    fontWeight: 700,
    border: "1px solid black",
    backgroundColor: "#d9d9d9",
    textAlign: "left",
    paddingLeft: "15px",
  };

  const textSubtotal = {
    fontWeight: 700,
    border: "1px solid black",
    backgroundColor: "#eeeeee",
  };

  const safeNumber = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
  };

  const getPersen = (labaRugi, netto) => {
    const totalLabaRugi = safeNumber(labaRugi);
    const totalNetto = safeNumber(netto);

    if (totalNetto === 0) return 0;
    return (totalLabaRugi / totalNetto) * 100;
  };

  const formatNumber = (value) => {
    const safeValue = safeNumber(value);
    return isCetakExcel === false
      ? safeValue.toLocaleString("en-EN")
      : safeValue;
  };

  const list = [];

  let grandTotalBruto = 0;
  let grandTotalPotongan = 0;
  let grandTotalNetto = 0;
  let grandTotalHpp = 0;
  let grandTotalLabaRugi = 0;
  let grandTotalPersenSum = 0;
  let grandTotalPersenCount = 0;

  if (lapPenjualanPerNotas.length > 0) {
    let currentTanggal = null;
    let nomorUrutPerTanggal = 0;

    let subTotalBruto = 0;
    let subTotalPotongan = 0;
    let subTotalNetto = 0;
    let subTotalHpp = 0;
    let subTotalLabaRugi = 0;
    let subTotalPersenSum = 0;
    let subTotalPersenCount = 0;

    for (let j = 0; j < lapPenjualanPerNotas.length; j++) {
      const row = lapPenjualanPerNotas[j];

      const totalBruto = safeNumber(row.totalBruto);
      const totalPotongan = safeNumber(row.totalPotongan);
      const totalNetto = safeNumber(row.totalNetto);
      const totalHpp = safeNumber(row.totalHpp);
      const totalLabaRugi = safeNumber(row.totalLabaRugi);
      const labaRugiPersen = getPersen(totalLabaRugi, totalNetto);

      const tanggalKey = row.tanggal
        ? new Date(row.tanggal).toISOString().split("T")[0]
        : "INVALID_DATE";

      if (currentTanggal !== tanggalKey) {
        if (currentTanggal !== null) {
          const subtotalPersen =
            subTotalPersenCount > 0
              ? subTotalPersenSum / subTotalPersenCount
              : 0;

          list.push(
            <tr key={`subtotal-${currentTanggal}`} style={tableText}>
              <td style={{ ...textSubtotal, textAlign: "center" }}></td>
              <td style={textSubtotal} colSpan={3}>
                SUBTOTAL {formatDate(new Date(currentTanggal))}
              </td>
              <td
                style={{ ...textNumberRightBold, backgroundColor: "#eeeeee" }}
              >
                {formatNumber(subTotalBruto)}
              </td>
              <td
                style={{ ...textNumberRightBold, backgroundColor: "#eeeeee" }}
              >
                {formatNumber(subTotalPotongan)}
              </td>
              <td
                style={{ ...textNumberRightBold, backgroundColor: "#eeeeee" }}
              >
                {formatNumber(subTotalNetto)}
              </td>
              <td
                style={{ ...textNumberRightBold, backgroundColor: "#eeeeee" }}
              >
                {formatNumber(subTotalHpp)}
              </td>
              <td
                style={{ ...textNumberRightBold, backgroundColor: "#eeeeee" }}
              >
                {formatNumber(subTotalLabaRugi)}
              </td>
              <td
                style={{ ...textNumberRightBold, backgroundColor: "#eeeeee" }}
              >
                {formatNumber(subtotalPersen)}
              </td>
            </tr>,
          );
        }

        currentTanggal = tanggalKey;
        nomorUrutPerTanggal = 0;

        subTotalBruto = 0;
        subTotalPotongan = 0;
        subTotalNetto = 0;
        subTotalHpp = 0;
        subTotalLabaRugi = 0;
        subTotalPersenSum = 0;
        subTotalPersenCount = 0;

        list.push(
          <tr key={`group-${tanggalKey}`} style={tableText}>
            <td style={textGroupHeader} colSpan={10}>
              TANGGAL : {formatDate(row.tanggal)}
            </td>
          </tr>,
        );
      }

      nomorUrutPerTanggal += 1;

      subTotalBruto += totalBruto;
      subTotalPotongan += totalPotongan;
      subTotalNetto += totalNetto;
      subTotalHpp += totalHpp;
      subTotalLabaRugi += totalLabaRugi;
      subTotalPersenSum += labaRugiPersen;
      subTotalPersenCount += 1;

      grandTotalBruto += totalBruto;
      grandTotalPotongan += totalPotongan;
      grandTotalNetto += totalNetto;
      grandTotalHpp += totalHpp;
      grandTotalLabaRugi += totalLabaRugi;
      grandTotalPersenSum += labaRugiPersen;
      grandTotalPersenCount += 1;

      list.push(
        <tr key={`row-${j}`} style={tableText}>
          <td style={textCenter}>{nomorUrutPerTanggal}</td>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {formatDate(row.tanggal)}
          </td>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {row.noNotaPenjualan}
          </td>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {row.namaJenisPembayaran}
          </td>

          <td style={textNumberRight}>{formatNumber(totalBruto)}</td>
          <td style={textNumberRight}>{formatNumber(totalPotongan)}</td>
          <td style={textNumberRight}>{formatNumber(totalNetto)}</td>
          <td style={textNumberRight}>{formatNumber(totalHpp)}</td>
          <td style={textNumberRight}>{formatNumber(totalLabaRugi)}</td>
          <td style={textNumberRight}>{formatNumber(labaRugiPersen)}</td>
        </tr>,
      );
    }

    if (currentTanggal !== null) {
      const subtotalPersen =
        subTotalPersenCount > 0 ? subTotalPersenSum / subTotalPersenCount : 0;

      list.push(
        <tr key={`subtotal-${currentTanggal}`} style={tableText}>
          <td style={{ ...textSubtotal, textAlign: "center" }}></td>
          <td style={textSubtotal} colSpan={3}>
            SUBTOTAL {formatDate(new Date(currentTanggal))}
          </td>
          <td style={{ ...textNumberRightBold, backgroundColor: "#eeeeee" }}>
            {formatNumber(subTotalBruto)}
          </td>
          <td style={{ ...textNumberRightBold, backgroundColor: "#eeeeee" }}>
            {formatNumber(subTotalPotongan)}
          </td>
          <td style={{ ...textNumberRightBold, backgroundColor: "#eeeeee" }}>
            {formatNumber(subTotalNetto)}
          </td>
          <td style={{ ...textNumberRightBold, backgroundColor: "#eeeeee" }}>
            {formatNumber(subTotalHpp)}
          </td>
          <td style={{ ...textNumberRightBold, backgroundColor: "#eeeeee" }}>
            {formatNumber(subTotalLabaRugi)}
          </td>
          <td style={{ ...textNumberRightBold, backgroundColor: "#eeeeee" }}>
            {formatNumber(subtotalPersen)}
          </td>
        </tr>,
      );
    }
  }

  const grandTotalPersen =
    grandTotalPersenCount > 0 ? grandTotalPersenSum / grandTotalPersenCount : 0;

  list.push(
    <tr key="grand-total" style={tableText}>
      <td style={textCenterBold}></td>
      <td style={textBold} colSpan={3}>
        TOTAL :
      </td>

      <td style={textNumberRightBold}>{formatNumber(grandTotalBruto)}</td>
      <td style={textNumberRightBold}>{formatNumber(grandTotalPotongan)}</td>
      <td style={textNumberRightBold}>{formatNumber(grandTotalNetto)}</td>
      <td style={textNumberRightBold}>{formatNumber(grandTotalHpp)}</td>
      <td style={textNumberRightBold}>{formatNumber(grandTotalLabaRugi)}</td>
      <td style={textNumberRightBold}>{formatNumber(grandTotalPersen)}</td>
    </tr>,
  );

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanPenjualanPerNota",
    sheet: "LaporanPenjualanPerNota",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Penjualan Per Nota</h5>
      <hr />

      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <Col sm={6}>
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={user.tipeUser !== "OWNER/DIREKSI" && error && kodeCabang.length === 0}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setPreviewPdf(false);
                      }}
                      value={
                        kodeCabang && namaCabang
                          ? {
                              label: namaCabang,
                              id: namaCabang,
                            }
                          : null
                      }
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>
                  Dari :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={dariTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setDariTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>
                  Sampai :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={sampaiTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setSampaiTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>

          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                  setIsCetakExcel(false);
                }, 1000);
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}

      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>

          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}
            | Jam:
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getMinutes().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>

          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Penjualan Per Nota
          </h5>

          <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${dariTanggal.getFullYear()}`}
          </p>

          <p>
            Sampai Tanggal :
            {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${sampaiTanggal.getFullYear()}`}
          </p>

          <p>Cabang : {namaCabang || "SEMUA CABANG"}</p>
          <p></p>

          <table className="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }}>NO</th>
                <th style={{ border: "1px solid black" }}>TANGGAL</th>
                <th style={{ border: "1px solid black" }}>NO. NOTA</th>
                <th style={{ border: "1px solid black" }}>JENIS PEMBAYARAN</th>
                <th style={{ border: "1px solid black", textAlign: "center" }}>
                  BRUTO
                </th>
                <th style={{ border: "1px solid black", textAlign: "center" }}>
                  POTONGAN
                </th>
                <th style={{ border: "1px solid black", textAlign: "center" }}>
                  NETTO
                </th>
                <th style={{ border: "1px solid black", textAlign: "center" }}>
                  HPP
                </th>
                <th style={{ border: "1px solid black", textAlign: "center" }}>
                  LABA RUGI
                </th>
                <th style={{ border: "1px solid black", textAlign: "center" }}>
                  % LABA RUGI
                </th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LaporanPenjualanPerNota;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};
